import * as Yup from "yup"

export const validateYupField = (schema: Yup.AnySchema) => (value: string) =>
	schema
		.validate(value)
		.then(() => undefined)
		.catch((err) => err.message)
